import { injectGlobal } from 'styled-components';
import { color } from './variables';

// Wash fonts
import WashingMachineExtrasEot from './webfonts/389094_0_0.eot';
import WashingMachineExtrasIefix from './webfonts/389094_0_0.eot?#iefix';
import WashingMachineExtrasWoff2 from './webfonts/389094_0_0.woff2';
import WashingMachineExtrasWoff from './webfonts/389094_0_0.woff';
import WashingMachineExtrasTtf from './webfonts/389094_0_0.ttf';

import WashingMachineEot from './webfonts/389094_1_0.eot';
import WashingMachineIefix from './webfonts/389094_1_0.eot?#iefix';
import WashingMachineWoff2 from './webfonts/389094_1_0.woff2';
import WashingMachineWoff from './webfonts/389094_1_0.woff';
import WashingMachineTtf from './webfonts/389094_1_0.ttf';

import WashingMachineBoldEot from './webfonts/389094_2_0.eot';
import WashingMachineBoldIefix from './webfonts/389094_2_0.eot?#iefix';
import WashingMachineBoldWoff2 from './webfonts/389094_2_0.woff2';
import WashingMachineBoldWoff from './webfonts/389094_2_0.woff';
import WashingMachineBoldTtf from './webfonts/389094_2_0.ttf';

export const globalStyles = injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Playfair+Display|Open+Sans:300,400,500,600,700');
  @import url("https://hello.myfonts.net/count/389094");
    
  @font-face {
    font-family: 'WashingMachineExtras';
    src: url(${WashingMachineExtrasEot});
    src: url(${WashingMachineExtrasIefix}) format('embedded-opentype'),
    url(${WashingMachineExtrasWoff2}) format('woff2'),
    url(${WashingMachineExtrasWoff}) format('woff'),
    url(${WashingMachineExtrasTtf}) format('truetype');
  }

  @font-face {
    font-family: 'WashingMachine';
    src: url(${WashingMachineEot});
    src: url(${WashingMachineIefix}) format('embedded-opentype'),
    url(${WashingMachineWoff2}) format('woff2'),
    url(${WashingMachineWoff}) format('woff'),
    url(${WashingMachineTtf}) format('truetype');
  }
  
  @font-face {
    font-family: 'WashingMachine-Bold';
    src: url(${WashingMachineBoldEot});
    src: url(${WashingMachineBoldIefix}) format('embedded-opentype'),
    url(${WashingMachineBoldWoff2}) format('woff2'),
    url(${WashingMachineBoldWoff}) format('woff'),
    url(${WashingMachineBoldTtf}) format('truetype');
  }  
  
  * {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  html {
    background-color: ${color.black};
    -webkit-text-size-adjust: 100%;
  }
  
  body {
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    position: relative;
    -webkit-font-smoothing: antialiased;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/helpers/global-styles.js